import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Panel, ObjectSelect2} from 'shared/components';

const Assignee = observer(({uiState}) => {
  const {assignee, availableAssignees, errors, policy} = uiState;

  return (
    <div>
      <Panel.Header
        title={t('time_tracking.manage.policies.edit.steps.Timesheet Manager')}
        description={policy.shiftSchedulingEnabled ?
          t('time_tracking.manage.policies.edit.Choose who will approve timesheets and manage shifts for employees in this policy.') :
          t('time_tracking.manage.policies.edit.Choose who will approve timesheets for employees in this policy.')}
      />
      <ObjectSelect2
        value={assignee}
        onChange={assignee => uiState.selectAssignee(assignee)}
        searchable={true}
        items={availableAssignees}
        errorMessage={errors.assigneeUserId}
      />
    </div>
  );
});

export default Assignee;
